// src/components/NewsletterSignup.jsx
import { useState } from "react";
import { doc, setDoc, serverTimestamp } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import "./NewsletterSignup.css";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // null | "loading" | "success" | "duplicate" | "error"

  async function handleSubmit(e) {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;

    setStatus("loading");
    try {
      // Using the email itself as the document ID means a repeat signup is
      // treated as an "update" by Firestore rules (since the doc already
      // exists) — which is blocked for public users, so it fails here and
      // we show a friendly "already subscribed" message. No public read
      // access to the subscriber list is needed at all.
      await setDoc(doc(db, "newsletterSubscribers", trimmed), {
        email: trimmed,
        subscribedAt: serverTimestamp(),
      });

      setStatus("success");
      setEmail("");
    } catch (err) {
      if (err.code === "permission-denied") {
        setStatus("duplicate");
      } else {
        console.error("Newsletter signup failed:", err);
        setStatus("error");
      }
    }
  }

  return (
    <section className="newsletter-section">
      <div className="container newsletter-inner">
        <h2>Exclusive Offers &amp; Printing Tips</h2>
        <p>Join thousands of Canadian customers who receive our best deals and design tips.</p>

        <form className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            required
            placeholder="Your email address"
            value={email}
            onChange={(e) => { setEmail(e.target.value); if (status) setStatus(null); }}
            disabled={status === "loading"}
          />
          <button type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Subscribing..." : "Subscribe"}
          </button>
        </form>

        {status === "success"   && <p className="newsletter-msg success">🎉 You're subscribed! Watch your inbox for exclusive offers.</p>}
        {status === "duplicate" && <p className="newsletter-msg info">You're already on our list — thank you!</p>}
        {status === "error"     && <p className="newsletter-msg error">Something went wrong. Please try again.</p>}
      </div>
    </section>
  );
}
